export const stylesCoinRow = {
  coinRow: {
    width: "276px",
    height: "64px !important",
    cursor: "pointer",
  },
  tableCell: {
    height: "64px !important",
    padding: "0 0 0 24px !important",
    border: "none",
    backgroundColor: "#FFFFFF",
    "&.MuiTableCell-root": {
      height: "64px !important",
      padding: "0 0 0 24px !important",
    },
  },
  textBox: {
    maxWidth: "190px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "flex",
    flexDirection: "column",
  },

  nameCellBox: {
    display: "flex",
    alignItems: "center",
    width: "276px",
    height: "64px",
    gap: 1.5,
  },
  nameText: {
    fontWeight: "500",
  },

  symbolText: {
    fontSize: "12px",
    color: "#76839b",
    fontWeight: "500",
  },
  sentimentIconBox: {
    ml: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "60px",
  },
  bearIcon: {
    width: "27px",
    height: "15px",
  },
  bullIcon: {
    width: "24px",
    height: "14px",
  },
  sentimentBox: (color: string) => ({
    display: "flex",
    alignItems: "center",
    color: color,
    fontWeight: 500,
  }),
  postsText: {
    color: "#2A2D31",
    fontSize: "14px",
    fontWeight: "500",
  },
  likeBox: {
    display: "flex",
    alignItems: "center",
    color: "#FF403D",
  },
  likeText: {
    color: "#2A2D31",
    fontSize: "14px",
    fontWeight: "500",
  },
  icon: {
    marginLeft: "24px",
    height: "40px",
    width: "40px",
  },
};
